import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue')
  },
  {
    path: '/rule',
    name: 'Rule',
    component: () => import(/* webpackChunkName: "Rule" */ '../views/Rule.vue')
  },
  {
    path: '/record',
    name: 'Record',
    component: () => import(/* webpackChunkName: "Rule" */ '../views/Record.vue')
  },
//   {
//     path: '/lottery',
//     name: 'Lottery',
//     component: () => import(/* webpackChunkName: "Rule" */ '../views/Lottery.vue')
//   },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
